function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L84 0L84 25L0 25L0 0Z",
  id: "nda_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "nda_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#nda_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "nda-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L84 0L84 25L0 25L0 0Z",
  id: "nda-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#nda_mask_1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0 -9)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M138 0L138 43L0 43L0 0L138 0Z",
  id: "Vector",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0 9.459961)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.64701 18.662L0 18.662L0 0L3.68977 0L6.71111 11.1705L6.71111 0L9.33139 0L9.33139 18.662L6.31005 18.662L2.64701 5.14538L2.64701 18.662ZM17.6692 0C19.1484 0 20.2489 0.3913 20.9708 1.17304C21.6927 1.95564 22.0541 3.10116 22.0541 4.61218L22.0541 14.0498C22.0541 15.5608 21.6927 16.7072 20.9708 17.489C20.2489 18.2716 19.1484 18.662 17.6692 18.662L13.0168 18.662L13.0168 0L17.6692 0ZM15.958 15.996L17.6157 15.996C18.0789 15.996 18.4437 15.8627 18.7111 15.5961C18.9785 15.3295 19.113 14.8582 19.113 14.1831L19.113 4.47888C19.113 3.80378 18.9793 3.3325 18.7119 3.0659C18.4446 2.7993 18.0789 2.666 17.6157 2.666L15.958 2.666L15.958 2.666L15.958 15.996ZM32.0229 18.662L31.514 15.2762L27.9045 15.2762L27.3965 18.662L24.6968 18.662L27.6906 0L31.9953 0L34.9899 18.662L32.0229 18.662ZM31.113 12.7435L29.6959 3.30584L28.2788 12.7435L28.2797 12.7435L31.113 12.7435Z",
  transform: "translate(32.774414 2.8378906)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.00781 3.44087L7.00781 2.56109C7.00781 1.27969 5.97799 0.134168 4.57642 0.0111881C2.97045 -0.126412 1.61719 1.02341 1.61719 2.45789L1.61719 3.44087L0 3.44087L0 11.18L8.625 11.18L8.625 3.44087L7.00781 3.44087ZM3.23437 6.88087C3.23437 6.33993 3.71996 5.89789 4.3125 5.89789C4.9059 5.89789 5.39062 6.33993 5.39062 6.88087C5.39062 7.42095 4.90504 7.86299 4.3125 7.86299C3.7191 7.86299 3.23437 7.42095 3.23437 6.88087ZM2.69531 2.45789C2.69531 1.64261 3.41809 0.983849 4.3125 0.983849C5.20691 0.983849 5.92969 1.64261 5.92969 2.45789L5.92969 3.44087L2.69531 3.44087L2.69531 2.45789Z",
  transform: "translate(7.7626953 6.020508)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.15 12.04C24.15 5.39048 18.7438 0 12.075 0C5.40615 0 0 5.39048 0 12.04C0 18.6895 5.40615 24.08 12.075 24.08C18.7438 24.08 24.15 18.6895 24.15 12.04ZM0.8625 12.04C0.8625 5.8652 5.88225 0.86 12.075 0.86C18.2677 0.86 23.2875 5.8652 23.2875 12.04C23.2875 18.2148 18.2677 23.22 12.075 23.22C5.88225 23.22 0.8625 18.2148 0.8625 12.04Z",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
})))));

var SvgNda = function SvgNda(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "25px",
    viewBox: "0 0 84 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNda, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nda.e89ec63c.svg";
export { ForwardRef as ReactComponent };